import { render } from "./PredictAPI.vue?vue&type=template&id=67ccc576&scoped=true"
import script from "./PredictAPI.vue?vue&type=script&lang=js"
export * from "./PredictAPI.vue?vue&type=script&lang=js"

import "./PredictAPI.vue?vue&type=style&index=0&id=67ccc576&scoped=true&lang=css"

import exportComponent from "/home/andre_merino/aihuk/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ccc576"]])

export default __exports__